import { z } from 'zod';

/** Resultado de uma checagem de dependência da API (banco, armazenamento). */
export const readinessCheckSchema = z.object({
  status: z.enum(['ok', 'error']),
  latencyMs: z.number(),
  /** Só o tipo do erro; o detalhe fica no log do servidor. */
  error: z.string().optional(),
});

/** Resposta de GET /ready. */
export const readySchema = z.object({
  status: z.enum(['ok', 'error']),
  checks: z.object({ database: readinessCheckSchema, storage: readinessCheckSchema }),
});

export type ReadinessCheck = z.infer<typeof readinessCheckSchema>;
export type ReadyResponse = z.infer<typeof readySchema>;
